import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo/Logo_Carpe_Diem.png";
import { useEffect, useState } from "react";
import "./header.css";
import { getHeaderContent } from "./headerContent";
import AnimatedScrollHeader from "../AnimatedScrollHeader/AnimatedScrollHeader";
import AnimatedScrollNav from "../AnimatedScrollNav/AnimatedScrollNav";
import { isAdminAuthenticated } from "../../utils/adminAuth";

const Header = () => {
  const location = useLocation();
  const headerContent = getHeaderContent();
  const { title, subtitle, image } = headerContent[location.pathname] || {
    title: "",
    subtitle: "",
    image: "",
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) setMenuOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const navbar = document.querySelector(".navbar_styled");
    const onScroll = () => {
      if (window.scrollY > 40) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const syncAdminAuth = async () => {
      const nextAuthState = await isAdminAuthenticated();

      if (!isMounted) {
        return;
      }

      setIsAdminLoggedIn((prevAuthState) =>
        prevAuthState === nextAuthState ? prevAuthState : nextAuthState,
      );
    };

    syncAdminAuth();

    const handleSync = () => {
      syncAdminAuth();
    };

    window.addEventListener("focus", handleSync);
    window.addEventListener("admin-auth-changed", handleSync);

    return () => {
      isMounted = false;
      window.removeEventListener("focus", handleSync);
      window.removeEventListener("admin-auth-changed", handleSync);
    };
  }, []);

  // Overlay pour fermer le menu burger en cliquant à côté
  const BurgerOverlay = () =>
    isTablet && menuOpen ? (
      <div
        className="burger-overlay"
        onClick={() => setMenuOpen(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          zIndex: 98,
        }}
      />
    ) : null;
  const isActive = (path) =>
    path === "/admin"
      ? location.pathname.startsWith("/admin")
      : location.pathname === path;

  return (
    <header>
      <div
        className="header_styled container_styled"
        style={{
          backgroundImage: `linear-gradient(rgba(73, 17, 28, 0), rgba(73, 17, 28, 0)), url(${image})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="navbar_styled">
          <div className="global_secondary secondary_font">
            <div className="logocontainer">
              <figure>
                <div className="link-wrapper">
                  <Link className="link" to="/">
                    <figure className="figure_lazy">
                      <img
                        color="default"
                        width="122"
                        className="logo-image header-logo"
                        alt="Navbar logo"
                        src={logo}
                      />
                    </figure>
                    <div className="img_overlay">
                      <div className="img_overlay_styled"></div>
                    </div>
                  </Link>
                </div>
              </figure>
            </div>
            <div className="projectLink">
              {isTablet && (
                <button
                  className={`hamburger-btn${menuOpen ? " open" : ""}`}
                  aria-label="Menu"
                  onClick={() => setMenuOpen((open) => !open)}
                  style={{
                    position: "fixed",
                    top: 18,
                    right: 18,
                    zIndex: 200,
                  }}
                >
                  <span />
                  <span />
                  <span />
                </button>
              )}
              <BurgerOverlay />

              {(() => {
                const navElement = (
                  <nav
                    className={`nav_link${isTablet ? " tablet" : ""}${
                      menuOpen ? " show" : ""
                    }`}
                    style={isTablet ? { zIndex: 150 } : {}}
                  >
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/"
                          className={`linkNav${isActive("/") ? " active" : ""}`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Accueil
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/menu"
                          className={`linkNav${
                            isActive("/menu") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Menu
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/notre-restaurant"
                          className={`linkNav${
                            isActive("/notre-restaurant") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Notre Restaurant
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/nos-chambres"
                          className={`linkNav${
                            isActive("/nos-chambres") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Nos Chambres
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/evenements"
                          className={`linkNav${
                            isActive("/evenements") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Événements
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/tourisme"
                          className={`linkNav${
                            isActive("/tourisme") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Tourisme
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>
                    <div className="linkStyle">
                      <div className="link-wrapper">
                        <Link
                          to="/contact"
                          className={`linkNav${
                            isActive("/contact") ? " active" : ""
                          }`}
                          onClick={() => setMenuOpen(false)}
                        >
                          <AnimatedScrollHeader watch={location.pathname}>
                            Contact
                          </AnimatedScrollHeader>
                        </Link>
                      </div>
                    </div>

                    {isAdminLoggedIn && (
                      <div className="linkStyle">
                        <div className="link-wrapper">
                          <Link
                            to="/admin"
                            className={`linkNav${
                              isActive("/admin") ? " active" : ""
                            }`}
                            onClick={() => setMenuOpen(false)}
                          >
                            <AnimatedScrollHeader watch={location.pathname}>
                              Admin
                            </AnimatedScrollHeader>
                          </Link>
                        </div>
                      </div>
                    )}

                    {/* Réseaux sociaux dans le menu burger/tablette/mobile */}
                    <div className="header-socials">
                      <div className="socialIcons">
                        <div className="link-wrapper ">
                          <a
                            aria-label="Social link"
                            className="linkLogo"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.facebook.com/p/CARPE-DIEM-12-61577135145308/"
                          >
                            <div
                              data-name="icon-facebook"
                              className="styled_svg"
                            >
                              <svg
                                className="svg_logo"
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                              >
                                <path d="M12.026 6.81v4.13H9v5.051h3.026V31h6.216V15.992h4.171s.391-2.422.58-5.07h-4.728V7.469c0-.516.678-1.21 1.348-1.21H23V1.001h-4.605c-6.523 0-6.369 5.055-6.369 5.81z"></path>
                              </svg>
                            </div>
                          </a>
                        </div>
                        <div className="link-wrapper ">
                          <a
                            aria-label="Social link"
                            className="linkLogo"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.instagram.com/carpediem_goutrens/"
                          >
                            <div
                              data-name="social-instagram"
                              className="styled_svg"
                            >
                              <svg
                                className="svg_logo"
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                              >
                                <path d="M16 8.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 12.188A4.695 4.695 0 0111.312 16c0-2.586 2.104-4.688 4.688-4.688s4.688 2.102 4.688 4.688A4.695 4.695 0 0116 20.688zm8.063-11.751a.999.999 0 110-1.997.999.999 0 010 1.997zM21.625 1h-11.25A9.376 9.376 0 001 10.375v11.25A9.376 9.376 0 0010.375 31h11.25A9.376 9.376 0 0031 21.625v-11.25A9.376 9.376 0 0021.625 1zm6.563 20.625a6.57 6.57 0 01-6.563 6.563h-11.25a6.57 6.57 0 01-6.563-6.563v-11.25a6.57 6.57 0 016.563-6.563h11.25a6.57 6.57 0 016.563 6.563v11.25z"></path>
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </nav>
                );

                return isTablet ? (
                  <AnimatedScrollNav watch={`${menuOpen}`} stagger={0.06}>
                    {navElement}
                  </AnimatedScrollNav>
                ) : (
                  navElement
                );
              })()}
            </div>
            <div className="projectLinkStyled">
              <div>
                <div>
                  <svg>
                    <path></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header_custom">
          <div>
            <AnimatedScrollHeader watch={location.pathname}>
              <div>
                <h1 className="h1_title">{title}</h1>
                {subtitle && <p className="p_header">{subtitle}</p>}
              </div>
            </AnimatedScrollHeader>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
